/**
 * ReDelivery v1
 * El delivery mas coopado
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ItemForAppStoreDto { 
    cdItem?: number;
    cdStore?: number;
    cdItemsCategory?: number;
    dsImg?: string;
    itemCategoryName?: string;
    dsName?: string;
    dsDescription?: string;
    qtMediumPrice?: number;
    isActive?: boolean;
    isBanner?: boolean;
    nmSortNo?: number;
}